var abc = {
    "backgroundOpacity": 1,
    "backgroundPadding": "-16",
    "radius": "60",
    "space": "0",
    "maxPercent": "100",
    "unitsFontSize": "11",
    "unitsColor": "#78bfdb",
    "outerStrokeWidth": "5",
    "outerStrokeColor": "#78bfdb",
    "outerStrokeLinecap": "butt",
    "innerStrokeColor": "#b0cab1",
    "innerStrokeWidth": "3",
    "titleColor": "#78bfdb",
    "titleFontSize": "19",
    "animationDuration": "1000",
    "showSubtitle": false,
    "showBackground": false
};
var DashboardModule = /** @class */ (function () {
    function DashboardModule() {
    }
    return DashboardModule;
}());
export { DashboardModule };
//# sourceMappingURL=dashboard.module.js.map